import { CelebrationButton } from "@components/adapters/celebration/Button";
import type { ButtonProps } from "@components/contracts/Button.types";

export const Button: React.FC<ButtonProps> = (props) => (
  <CelebrationButton {...props} />
);

export type { ButtonProps };
